export default __webpack_public_path__ + "static/media/bg_terminal.87771761.png";